<p-dialog
  header="Consimțământ GDPR"
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(550px, 95vw)' }"
  [breakpoints]="{ '600px': '95vw' }">

  <div class="flex flex-col gap-4">
    <p class="text-sm text-gray-700 leading-relaxed">
      Pentru a utiliza platforma FaunaGo, avem nevoie de consimțământul dumneavoastră
      privind prelucrarea datelor personale, în conformitate cu Regulamentul General
      privind Protecția Datelor (GDPR).
    </p>

    <div class="bg-gray-50 p-4 rounded-lg border">
      <h4 class="font-bold text-sm mb-2">Date colectate:</h4>
      <ul class="text-sm text-gray-600 space-y-1 list-disc pl-4">
        <li>Nume și prenume</li>
        <li>Data nașterii (opțional, pentru determinarea vârstei)</li>
        <li>Fotografie de profil</li>
        <li>Date de profil primite de la furnizori terți de autentificare (ex. Orgo / membri.scout.ro)</li>
        <li>Observații și date de localizare</li>
      </ul>
    </div>

    <div class="flex flex-col gap-3">
      <div class="flex items-start gap-3 p-3 rounded-lg border" [class.border-red-300]="error() && !dataProcessing()">
        <p-checkbox
          [binary]="true"
          [(ngModel)]="dataProcessing"
          inputId="gdpr_data_processing" />
        <label for="gdpr_data_processing" class="text-sm cursor-pointer">
          <span class="font-medium">Prelucrarea datelor personale</span>
          <span class="block text-gray-500 text-xs mt-0.5">
            Sunt de acord ca datele mele să fie folosite pentru afișarea observațiilor pe platformă și pentru funcționarea serviciului.
            <span class="text-red-500">*</span>
          </span>
        </label>
      </div>

      <div class="flex items-start gap-3 p-3 rounded-lg border">
        <p-checkbox
          [binary]="true"
          [(ngModel)]="notifications"
          inputId="gdpr_notifications" />
        <label for="gdpr_notifications" class="text-sm cursor-pointer">
          <span class="font-medium">Notificări</span>
          <span class="block text-gray-500 text-xs mt-0.5">
            Sunt de acord să primesc notificări din aplicație (opțional).
          </span>
        </label>
      </div>
    </div>

    @if (error()) {
      <p class="text-red-600 text-sm">{{ error() }}</p>
    }

    <p class="text-xs text-gray-500">
      Consultați
      <a routerLink="/confidentialitate" class="text-faunago-blue underline" (click)="visible.set(false)">Politica de Confidențialitate</a>
      și
      <a routerLink="/termeni" class="text-faunago-blue underline" (click)="visible.set(false)">Termenii și Condițiile</a>
      pentru informații complete. Puteți modifica aceste preferințe oricând din profilul dumneavoastră.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Confirm Consimțământul"
      icon="pi pi-check"
      (onClick)="submit()"
      [loading]="submitting()"
      [disabled]="!dataProcessing()" />
  </ng-template>
</p-dialog>
